/*
|---------------------------------------------------------------------
| Cotizaciones Vuex State
|---------------------------------------------------------------------
|
| Kanban board initial cards state from content demo
|
*/
export default {
    step: 1,
    data: {
      files_path: []
    },
    items: [],
    documents: [],
    email: {
      presentacion: true,
      destinatarios: [],
      reply_to: []
    },

    //Proyecto
    Proyecto_Completo: {
      cotizaciones: [],
      id: 0
    },

    //Datos Generales
    load_datosGenerales: {
      _files_path: [],
      _users: []
    },
    //Configuracion de Propuestas
    load_propuestas: {
      _items: [],
      _items_: [],
      _categorias: [],
      _meses_contrato: [],
      _plazo_pago: [],
      _plazo_habilitacion: []
    },

    //Datos
    all_data: {
      data: {
        files_path: [],
      },
      final_files_path: [],
      items: [],
      items_: [],
      documents: [],
      files_temp: [],
      email: {
        presentacion: true,
        destinatarios: [],
        reply_to: [],
      },

      form: {
        asunto: "",
        mensaje: "",
      },

      termino_validez_temp: null,
      comentario_temp: null,

      path_presentacion: null,
      borrador: false,
      selectedPropuesta: null,
      nombre_destinatario: "",
      email_destinatario: "",
      email_reply_to: "",
      nombre_reply_to: "",
      showAddDestinatarioDialog: false,
      createDialog: false,
      servicio: null,

      users: [],
      mesesContratoOptions: [],
      plazoPagoOptions: [],
      plazoHabilitacionOptions: [],
      //periodicidadOptions: [],

      urlPortal: process.env.VUE_APP_PORTAL,
      loading: false,
      load: false,
      borrador: false
    },

    temp_data: {
      data: {
        files_path: []
      },
      items: [],
      documents: [],
      email: {
        presentacion: true,
        destinatarios: [],
        reply_to: []
      }
    }

}
